import { render } from "./VoyageStop.vue?vue&type=template&id=80ae483a&scoped=true"
import script from "./VoyageStop.vue?vue&type=script&lang=js"
export * from "./VoyageStop.vue?vue&type=script&lang=js"

import "./VoyageStop.vue?vue&type=style&index=0&id=80ae483a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ae483a"]])

export default __exports__